var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BBBBBB;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,1.8c2.3,2.3,2.3,6.1,0,8.5s-6.1,2.3-8.5,0s-2.3-6.1,0-8.5c0,0,0,0,0,0C4.1-0.6,7.9-0.6,10.2,1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.5,8.1l1.4,1.4L6,7.4l2.1,2.1l1.4-1.4L7.4,6l2.1-2.1L8.1,2.5L6,4.6L3.9,2.5L2.5,3.9L4.6,6L2.5,8.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossOff);
export default __webpack_public_path__ + "static/media/cross_off.6cdd82f012497269e9fe4de41cf4e59b.svg";
export { ForwardRef as ReactComponent };